import { Form } from 'antd';
import GenericInput from 'components/form/shared/GenericInput';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { IContactUsSchema } from './schema/contactUs';

const StaticPageContactUsForm = () => {
  const {
    control,
    formState: { errors },
    ...rest
  } = useFormContext<IContactUsSchema>();

  return (
    <Form layout="vertical">
      <GenericInput control={control} name="title" label="Title" required errors={errors['title']} {...rest} />
      <GenericInput
        control={control}
        name="body"
        label="Content"
        required
        errors={errors['body']}
        type="quill"
        descriptionAfter="Content of the page"
        {...rest}
      />
    </Form>
  );
};

export default memo(StaticPageContactUsForm);
